import React from 'react';
import Typography from '@material-ui/core/Typography';
import MuiLink from '@material-ui/core/Link';
import { Link } from 'react-router-dom';

export const clientNameFormatter = (cell, row) => (
  <>
    <Typography variant="subtitle1">
      <MuiLink component={Link} to={`/oauth-clients/${row.id}`}>
        {row.name}
      </MuiLink>
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {row.id}
    </Typography>
  </>
);

export default clientNameFormatter;
